import React from 'react';

interface IconUploadProps {
  className?: string;
  size?: string | number;
}

const IconUpload = (props: IconUploadProps) => {
  const size = props.size ?? '24';

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      className={props.className}
    >
      <path
        fill="currentColor"
        d="M11.5 15.577v-8.65l-2.33 2.33l-.708-.718L12 5l3.539 3.539l-.708.719L12.5 6.927v8.65zM6.616 19q-.691 0-1.153-.462T5 17.384v-2.423h1v2.423q0 .231.192.424t.423.192h10.77q.23 0 .423-.192t.192-.424v-2.423h1v2.423q0 .691-.462 1.153T17.384 19z"
      />
    </svg>
  );
};

export default IconUpload;
